/**
 * @typedef {Record<string, string | number | boolean | null | undefined>} AnalyticsParams
 */

function isPrerenderBuild() {
  if (typeof window === 'undefined') return false;
  return Boolean(
    /** @type {Window & { __PRERENDER_BUILD__?: boolean }} */ (window).__PRERENDER_BUILD__,
  );
}

/**
 * Safely sends a GA4 event if gtag is available.
 *
 * @param {string} eventName
 * @param {AnalyticsParams} [params]
 */
export const gaEvent = (eventName, params) => {
  if (typeof window === 'undefined') return;
  if (isPrerenderBuild()) return;
  const win = /** @type {Window & { gtag?: (...args: unknown[]) => void }} */ (window);
  if (typeof win.gtag !== 'function') return;

  try {
    win.gtag('event', eventName, params || {});
  } catch {
    // Intentionally swallow analytics failures to keep UX non-blocking.
  }
};

/**
 * Safely sends a Microsoft Clarity custom event if clarity is available.
 *
 * @param {string} eventName
 */
export const clarityEvent = (eventName) => {
  if (typeof window === 'undefined') return;
  if (isPrerenderBuild()) return;
  const win = /** @type {Window & { clarity?: (...args: unknown[]) => void }} */ (window);
  if (typeof win.clarity !== 'function') return;

  try {
    win.clarity('event', eventName);
  } catch {
    // Intentionally swallow analytics failures to keep UX non-blocking.
  }
};

/**
 * Adds a custom Clarity session tag for filtering recordings.
 *
 * @param {string} key
 * @param {string} value
 */
export const claritySet = (key, value) => {
  if (typeof window === 'undefined') return;
  if (isPrerenderBuild()) return;
  const win = /** @type {Window & { clarity?: (...args: unknown[]) => void }} */ (window);
  if (typeof win.clarity !== 'function') return;

  try {
    win.clarity('set', key, value);
  } catch {
    // Intentionally swallow analytics failures to keep UX non-blocking.
  }
};
